export default __webpack_public_path__ + "static/media/Panel-documentation.52ac2fd9.md";